import React, { useState } from "react";

import MSummary from "./PunctualityPerformance/PunctualitySummary/MSummary";
import { flattenData } from "../../Utilitie";
import Report02 from "./PunctualityPerformance/PunctualitySummary/Report02";
import ReportMaster from "./PunctualityPerformance/PunctualitySummary/ReportMaster";
import LTSummaryMaster from "./PunctualityLostTrainSummary/LTSummaryMaster";
import PunBestEverDataMaster from "./Best Ever Data/PunBestEverDataMaster";
const PunctualitySummary = ({ data }) => {
  const [activePage, setActivePage] = useState("icms_report02");
  //   const tempData = flattenData(data);
  //   const years = [...new Set(tempData.map((t) => t.F_YEAR))].sort(
  //     (a, b) => Number(a.replace("_", "")) - Number(b.replace("_", ""))
  //   );
  const pageName = [
    "icms_report02",
    "Lost Train Summary",
    "Best Ever Data",
    // "Head Wise",
  ];

  return (
    <div className="row m-1">
      <div
        className=" col-md-2 newUiBody  d-flex flex-column "
        style={{ height: "90vh" }}
      >
        {pageName.map((page) => {
          return (
            <button
              className={` col m-1 btn btn-sm btn-outline-dark Subject ${
                activePage === page && "active"
              }`}
              style={{ maxHeight: "50px" }}
              onClick={() => {
                setActivePage(page);
              }}
            >
              {page}
            </button>
          );
        })}
      </div>
      <div className="col-md-10 papDiv">
        {activePage === "icms_report02" && <ReportMaster />}
        {activePage === "Lost Train Summary" && <LTSummaryMaster />}
        {activePage === "Best Ever Data" && <PunBestEverDataMaster />}

        {/* {activePage === "Station & Section Wise" && (
          <StationSectionWise data={tempData} more={{ years: years }} />
        )}
        {activePage === "Month Wise" && (
          <MonthWise data={tempData} more={{ years: years }} />
        )} */}
        {/* {activePage === "Head Wise" && (
          <HeadWise data={tempData} more={{ years: years }} />
        )} */}
      </div>
    </div>
  );
};
export default PunctualitySummary;
